/**
 * Normalize marketing banner payload before create/update API calls.
 */

import { htmlToPlainText } from '@/components/marketingBanners/htmlToPlainText';
import type { CreateMarketingBannerRequest } from '@/app/types/marketingBanners';

export function normalizeMarketingBannerRequest(
  request: CreateMarketingBannerRequest,
): CreateMarketingBannerRequest {
  const staticContent = request.static_content;
  if (!staticContent) {
    return request;
  }

  const rawMessages = staticContent.messages ?? [];
  const messages = rawMessages
    .map((message) => ({
      id: message.id,
      text: message.text,
      animation: message.animation ?? 'none',
    }))
    .filter((message) => htmlToPlainText(message.text).length > 0);

  return {
    ...request,
    static_content: {
      ...staticContent,
      messages,
    },
  };
}
